(()=>{
  const init=()=>{
    const header=document.getElementById('shopify-section-header');
    if(!header||header.dataset.amStickyInitialized)return;
    header.dataset.amStickyInitialized='true';
    const logo=header.querySelector('.site-header__logo');
    const image=logo&&logo.querySelector('img');
    const column=logo&&logo.parentElement;
    const mobile=window.matchMedia('(max-width:768px)');
    const spacer=document.createElement('div');
    spacer.className='am-header-spacer';
    spacer.setAttribute('aria-hidden','true');
    header.parentNode.insertBefore(spacer,header);
    let compact=false,pending=false,lastWidth=0,lastRatio=0;
    const fitMobileLogo=(force=false)=>{
      if(!mobile.matches){
        header.classList.remove('am-mobile-header-ready');
        lastWidth=0;lastRatio=0;
        return;
      }
      if(!column||!image||!image.naturalWidth||!image.naturalHeight)return;
      const style=window.getComputedStyle(column);
      const available=column.clientWidth-parseFloat(style.paddingLeft||0)-parseFloat(style.paddingRight||0);
      const ratio=image.naturalHeight/image.naturalWidth;
      if(available<=0||(!force&&available===lastWidth&&ratio===lastRatio))return;
      lastWidth=available;lastRatio=ratio;
      const expanded=Math.min(240,available),small=Math.min(140,available);
      header.classList.add('am-header--measuring');
      header.classList.remove('am-header--compact');
      header.style.setProperty('--am-mobile-logo-expanded',expanded+'px');
      header.style.setProperty('--am-mobile-logo-compact',small+'px');
      header.style.setProperty('--am-mobile-logo-height',expanded*ratio+'px');
      header.style.setProperty('--am-mobile-logo-small-height',small*ratio+'px');
      header.style.setProperty('--am-mobile-logo-scale',String(small/expanded));
      header.classList.add('am-mobile-header-ready');
      // This spacer stays at the expanded height while the fixed header shrinks.
      spacer.style.setProperty('--am-header-space',header.offsetHeight+'px');
      if(compact)header.classList.add('am-header--compact');
      void header.offsetHeight;
      header.classList.remove('am-header--measuring');
    };
    const update=()=>{
      pending=false;
      if(document.body.classList.contains('js-drawer-open'))return;
      const y=Math.max(0,window.scrollY);
      if(!compact&&y>160){compact=true;header.classList.add('am-header--compact')}
      else if(compact&&y<20){compact=false;header.classList.remove('am-header--compact')}
    };
    fitMobileLogo(true);
    if(image)image.addEventListener('load',()=>fitMobileLogo(true));
    if(column&&'ResizeObserver' in window)new ResizeObserver(()=>fitMobileLogo()).observe(column);
    window.addEventListener('resize',()=>fitMobileLogo(),{passive:true});
    window.addEventListener('scroll',()=>{
      if(!pending){pending=true;requestAnimationFrame(update)}
    },{passive:true});
    window.addEventListener('pageshow',()=>{fitMobileLogo(true);update()});
    update();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();